export const TRANSLATIONS = {
  es: {
    app_name: "Deslinde Pro",
    app_tagline: "Gestión de Expedientes de Deslinde",
    nav_dashboard: "Panel",
    nav_new: "Nuevo Expediente",
    nav_profile: "Mi Perfil",
    new_expediente: "Nuevo Expediente",
    edit_expediente: "Editar Expediente",
    expedientes: "Expedientes",
    no_expedientes: "Sin expedientes todavía",
    no_expedientes_desc: "Crea tu primer expediente para comenzar el proceso de deslinde.",
    create_first: "Crear primer expediente",
    create: "Crear",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    open: "Abrir",
    back: "Volver",
    progress: "Progreso",
    status: "Estado",
    actions: "Acciones",
    numero_expediente: "Número de Expediente",
    titulo_expediente: "Título / Referencia",
    tipo_operacion: "Tipo de operación",
    drmc_departamento: "DRMC — Departamento",
    created_at: "Creado",
    updated_at: "Actualizado",
    tab_datos: "Datos",
    tab_documentos: "Documentos",
    tab_fotos: "Fotos",
    tab_resultados: "Resultados / Medición",
    tab_timeline: "Línea de tiempo",
    section_general: "General",
    section_cliente: "Datos del Cliente",
    section_acto_venta: "Acto de Venta",
    section_notario: "Notario (Acto / Contrato)",
    section_titulo: "Certificado de Título",
    section_terreno: "Terreno y Colindantes",
    section_honorarios: "Honorarios y Pago",
    cliente_nombre: "Nombre completo",
    cliente_cedula: "Cédula",
    cliente_nacionalidad: "Nacionalidad",
    cliente_sexo: "Sexo",
    cliente_estado_civil: "Estado civil",
    cliente_profesion: "Profesión / Ocupación",
    cliente_direccion: "Dirección",
    cliente_telefono: "Teléfono",
    cliente_email: "Email",
    not_nombre: "Nombre del notario",
    not_matricula: "Matrícula del notario",
    not_municipio: "Municipio del Colegio",
    av_numero: "Número del Acto",
    av_fecha: "Fecha",
    av_vendedor: "Vendedor",
    av_comprador: "Comprador",
    av_precio: "Precio",
    tit_numero: "No. Certificado de Título",
    tit_matricula: "Matrícula",
    tit_designacion: "Designación catastral",
    tit_parcela: "Parcela",
    tit_dc: "D.C. (Distrito Catastral)",
    tit_superficie: "Superficie",
    tit_seccion: "Sección",
    tit_lugar: "Lugar / Sitio",
    tit_municipio: "Municipio",
    tit_provincia: "Provincia",
    tit_fecha: "Fecha de emisión",
    ter_direccion: "Dirección del terreno",
    ter_referencias: "Referencias de ubicación (texto largo)",
    ter_coordenadas: "Coordenadas (lat, lon)",
    ter_norte: "Colindante Norte",
    ter_sur: "Colindante Sur",
    ter_este: "Colindante Este",
    ter_oeste: "Colindante Oeste",
    ter_mat_norte: "Materialización Norte",
    ter_mat_sur: "Materialización Sur",
    ter_mat_este: "Materialización Este",
    ter_mat_oeste: "Materialización Oeste",
    ter_tipo_construccion: "Tipo de construcción",
    hon_moneda: "Moneda",
    hon_monto_1: "1ra cuota (monto)",
    hon_monto_1_letras: "1ra cuota (en letras)",
    hon_condicion_1: "1ra cuota — condición",
    hon_pagado_1: "1ra cuota pagada",
    hon_monto_2: "2da cuota (monto)",
    hon_monto_2_letras: "2da cuota (en letras)",
    hon_condicion_2: "2da cuota — condición",
    hon_pagado_2: "2da cuota pagada",
    hon_fecha: "Fecha del contrato",
    hon_municipio: "Municipio del contrato",
    hon_pendiente: "Honorarios pendientes",
    hon_cobrado: "Cobrado",
    hon_total: "Total",
    hon_use_notario_autorizacion: "Usar el mismo notario de la Autorización en el Contrato",
    sr_parcela_resultante_2: "Parcela resultante 2 (opcional)",
    sr_area_resultante_2: "Área resultante 2 (opcional)",
    sr_auto: "Auto-completar desde No. Exp.",
    sr_fecha_autorizacion: "Fecha de autorización DRMC",
    sr_fecha_medicion: "Fecha de medición",
    sr_hora_inicio: "Hora de inicio",
    sr_hora_fin: "Hora de finalización",
    sr_parcela_resultante: "Parcela resultante (provisional)",
    sr_area_titulo: "Área según título",
    sr_area_derecho: "Área de derecho",
    sr_area_presentada: "Área presentada",
    sr_area_resultante: "Área resultante",
    sr_diferencia: "Diferencia",
    sr_metodo_levantamiento: "Método de levantamiento",
    sr_instrumento: "Instrumento",
    sr_metodo_orientacion: "Método de orientación",
    sr_observaciones: "Observaciones",
    doc_contrato: "Contrato de Servicios Profesionales",
    doc_solicitud: "Solicitud de Autorización",
    doc_solicitud_prorroga: "Solicitud de Prórroga",
    doc_aviso_mensuras: "Aviso de Mensuras (a la DRMC)",
    doc_notif_norte: "Notificación al Colindante Norte",
    doc_notif_sur: "Notificación al Colindante Sur",
    doc_notif_este: "Notificación al Colindante Este",
    doc_notif_oeste: "Notificación al Colindante Oeste",
    doc_aviso_medio_ambiente: "Aviso a Medio Ambiente",
    doc_aviso_ayuntamiento: "Aviso al Ayuntamiento",
    doc_aviso_tribunal: "Aviso al Tribunal de Tierras",
    doc_publicacion: "Publicación en Periódico",
    doc_letrero: "Orden de Letrero",
    doc_carta_conformidad: "Carta de Conformidad DRMC",
    doc_declaracion_posesion: "Declaración de Posesión",
    doc_informe_tecnico: "Informe Técnico",
    doc_acta_hitos: "Acta de Hitos y Mensura",
    doc_resultados: "Resultados de Medición",
    doc_fotos_linderos: "Fotos de Linderos",
    doc_fotos_letrero: "Fotos del Aviso de Mensura",
    doc_instancia_duplicado: "Instancia al Registro de Títulos",
    doc_declaracion_jurada: "Declaración Jurada de Pérdida",
    doc_compulsa: "Compulsa Notarial",
    doc_publicacion_perdida: "Publicación de Pérdida (Periódico)",
    doc_declaracion_posesion_mejora: "Declaración Jurada de Posesión y Mejora",
    doc_compulsa_posesion: "Compulsa de Declaración de Posesión",
    doc_poder_representacion: "Poder Especial de Representación",
    generate: "Generar PDF",
    upload_photo: "Subir foto",
    remove: "Quitar",
    photo_norte: "Lindero Norte",
    photo_sur: "Lindero Sur",
    photo_este: "Lindero Este",
    photo_oeste: "Lindero Oeste",
    photo_letrero_1: "Letrero — Vista 1",
    photo_letrero_2: "Letrero — Vista 2",
    timeline_steps: {
      contrato_firmado: "Contrato firmado",
      solicitud_autorizacion_generada: "Solicitud de autorización generada",
      solicitud_notarizada: "Solicitud notarizada",
      avisos_enviados: "Avisos enviados",
      publicacion_periodico: "Publicación en periódico",
      letrero_colocado: "Letrero colocado",
      medicion_realizada: "Medición realizada",
      plano_preparado: "Plano y expediente preparado",
      expediente_depositado: "Expediente depositado",
    },
    confirm_delete: "¿Eliminar este expediente? Esta acción no se puede deshacer.",
    saved: "Guardado",
    error: "Error",
    required_number: "El número de expediente es requerido",
    docs_section_title: "Generación de Documentos",
    docs_section_desc: "Cada PDF se genera con los datos del expediente y de tu perfil de agrimensor.",
    photos_section_title: "Fotografías del Expediente",
    photos_section_desc: "Sube 6 fotos: 4 de los linderos (N/S/E/O) y 2 del letrero de aviso de mensura.",
    results_section_title: "Datos del Levantamiento",
    results_section_desc: "Coloca los datos resultantes de la medición para generar el informe técnico, acta de hitos y carta de conformidad.",
    overview: "Resumen",
    profile_title: "Perfil del Agrimensor",
    profile_desc: "Estos datos se insertarán automáticamente en todos los PDFs.",
    profile_nombre: "Nombre completo",
    profile_nacionalidad: "Nacionalidad",
    profile_sexo: "Sexo",
    profile_estado_civil: "Estado civil",
    profile_cedula: "Cédula",
    profile_codia: "CODIA",
    profile_tel1: "Teléfono 1",
    profile_tel2: "Teléfono 2",
    profile_email: "Correo electrónico",
    profile_direccion: "Dirección",
  },
  en: {
    app_name: "Deslinde Pro",
    app_tagline: "Land Survey Case Management",
    nav_dashboard: "Dashboard",
    nav_new: "New Case",
    nav_profile: "My Profile",
    new_expediente: "New Case",
    edit_expediente: "Edit Case",
    expedientes: "Cases",
    no_expedientes: "No cases yet",
    no_expedientes_desc: "Create your first case to begin the survey process.",
    create_first: "Create first case",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    open: "Open",
    back: "Back",
    progress: "Progress",
    status: "Status",
    actions: "Actions",
    numero_expediente: "Case Number",
    titulo_expediente: "Title / Reference",
    tipo_operacion: "Operation type",
    drmc_departamento: "DRMC — Department",
    created_at: "Created",
    updated_at: "Updated",
    tab_datos: "Data",
    tab_documentos: "Documents",
    tab_fotos: "Photos",
    tab_resultados: "Survey Results",
    tab_timeline: "Timeline",
    section_general: "General",
    section_cliente: "Client Data",
    section_acto_venta: "Sale Deed",
    section_notario: "Notary (Deed / Contract)",
    section_titulo: "Title Certificate",
    section_terreno: "Property & Neighbors",
    section_honorarios: "Fees & Payment",
    cliente_nombre: "Full name",
    cliente_cedula: "ID",
    cliente_nacionalidad: "Nationality",
    cliente_sexo: "Sex",
    cliente_estado_civil: "Marital status",
    cliente_profesion: "Profession",
    cliente_direccion: "Address",
    cliente_telefono: "Phone",
    cliente_email: "Email",
    not_nombre: "Notary name",
    not_matricula: "Notary registry no.",
    not_municipio: "Notary municipality",
    av_numero: "Deed number",
    av_fecha: "Date",
    av_vendedor: "Seller",
    av_comprador: "Buyer",
    av_precio: "Price",
    tit_numero: "Title No.",
    tit_matricula: "Registry No.",
    tit_designacion: "Cadastral designation",
    tit_parcela: "Parcel",
    tit_dc: "Cadastral district",
    tit_superficie: "Surface area",
    tit_seccion: "Section",
    tit_lugar: "Place / Site",
    tit_municipio: "Municipality",
    tit_provincia: "Province",
    tit_fecha: "Issue date",
    ter_direccion: "Property address",
    ter_referencias: "Location reference (long text)",
    ter_coordenadas: "Coordinates (lat, lon)",
    ter_norte: "North neighbor",
    ter_sur: "South neighbor",
    ter_este: "East neighbor",
    ter_oeste: "West neighbor",
    ter_mat_norte: "North materialization",
    ter_mat_sur: "South materialization",
    ter_mat_este: "East materialization",
    ter_mat_oeste: "West materialization",
    ter_tipo_construccion: "Construction type",
    hon_moneda: "Currency",
    hon_monto_1: "1st payment (amount)",
    hon_monto_1_letras: "1st payment (in words)",
    hon_condicion_1: "1st payment — condition",
    hon_pagado_1: "1st payment received",
    hon_monto_2: "2nd payment (amount)",
    hon_monto_2_letras: "2nd payment (in words)",
    hon_condicion_2: "2nd payment — condition",
    hon_pagado_2: "2nd payment received",
    hon_fecha: "Contract date",
    hon_municipio: "Contract location",
    hon_pendiente: "Outstanding fees",
    hon_cobrado: "Collected",
    hon_total: "Total",
    hon_use_notario_autorizacion: "Use the Authorization notary in the Contract",
    sr_parcela_resultante_2: "Resulting parcel 2 (optional)",
    sr_area_resultante_2: "Resulting area 2 (optional)",
    sr_auto: "Auto-fill from Case No.",
    sr_fecha_autorizacion: "DRMC authorization date",
    sr_fecha_medicion: "Survey date",
    sr_hora_inicio: "Start time",
    sr_hora_fin: "End time",
    sr_parcela_resultante: "Resulting parcel (provisional)",
    sr_area_titulo: "Area per title",
    sr_area_derecho: "Rightful area",
    sr_area_presentada: "Presented area",
    sr_area_resultante: "Resulting area",
    sr_diferencia: "Difference",
    sr_metodo_levantamiento: "Survey method",
    sr_instrumento: "Instrument",
    sr_metodo_orientacion: "Orientation method",
    sr_observaciones: "Notes",
    doc_contrato: "Service Contract",
    doc_solicitud: "Authorization Request",
    doc_solicitud_prorroga: "Extension Request",
    doc_aviso_mensuras: "Notice to DRMC",
    doc_notif_norte: "Notice to North neighbor",
    doc_notif_sur: "Notice to South neighbor",
    doc_notif_este: "Notice to East neighbor",
    doc_notif_oeste: "Notice to West neighbor",
    doc_aviso_medio_ambiente: "Notice to Environment Ministry",
    doc_aviso_ayuntamiento: "Notice to Municipality",
    doc_aviso_tribunal: "Notice to Land Court",
    doc_publicacion: "Newspaper Publication",
    doc_letrero: "Survey Sign Order",
    doc_carta_conformidad: "Conformity Letter DRMC",
    doc_declaracion_posesion: "Possession Declaration",
    doc_informe_tecnico: "Technical Report",
    doc_acta_hitos: "Survey & Boundary Act",
    doc_resultados: "Survey Results Report",
    doc_fotos_linderos: "Boundary Photos",
    doc_fotos_letrero: "Survey Sign Photos",
    doc_instancia_duplicado: "Instancia to Title Registry",
    doc_declaracion_jurada: "Sworn Declaration of Loss",
    doc_compulsa: "Notarial Compulsa",
    doc_publicacion_perdida: "Loss Publication (Newspaper)",
    doc_declaracion_posesion_mejora: "Sworn Possession & Improvement",
    doc_compulsa_posesion: "Possession Compulsa",
    doc_poder_representacion: "Special Power of Attorney",
    generate: "Generate PDF",
    upload_photo: "Upload photo",
    remove: "Remove",
    photo_norte: "North boundary",
    photo_sur: "South boundary",
    photo_este: "East boundary",
    photo_oeste: "West boundary",
    photo_letrero_1: "Sign — View 1",
    photo_letrero_2: "Sign — View 2",
    timeline_steps: {
      contrato_firmado: "Contract signed",
      solicitud_autorizacion_generada: "Authorization request generated",
      solicitud_notarizada: "Request notarized",
      avisos_enviados: "Notices sent",
      publicacion_periodico: "Newspaper publication",
      letrero_colocado: "Sign placed",
      medicion_realizada: "Survey performed",
      plano_preparado: "Plan and file prepared",
      expediente_depositado: "File deposited",
    },
    confirm_delete: "Delete this case? This action cannot be undone.",
    saved: "Saved",
    error: "Error",
    required_number: "Case number is required",
    docs_section_title: "Document Generation",
    docs_section_desc: "Each PDF is prefilled with the case data and your surveyor profile.",
    photos_section_title: "Case Photographs",
    photos_section_desc: "Upload 6 photos: 4 boundaries (N/S/E/W) and 2 of the survey notice sign.",
    results_section_title: "Survey Data",
    results_section_desc: "Enter the measurement results to generate the technical report, boundary act and conformity letter.",
    overview: "Overview",
    profile_title: "Surveyor Profile",
    profile_desc: "This data is automatically embedded into all generated PDFs.",
    profile_nombre: "Full name",
    profile_nacionalidad: "Nationality",
    profile_sexo: "Sex",
    profile_estado_civil: "Marital status",
    profile_cedula: "ID",
    profile_codia: "CODIA",
    profile_tel1: "Phone 1",
    profile_tel2: "Phone 2",
    profile_email: "Email",
    profile_direccion: "Address",
  }
};

import { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext({ lang: "es", t: TRANSLATIONS.es, setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("deslinde_lang") || "es");
  useEffect(() => { localStorage.setItem("deslinde_lang", lang); }, [lang]);
  const t = TRANSLATIONS[lang] || TRANSLATIONS.es;
  return <LangContext.Provider value={{ lang, t, setLang }}>{children}</LangContext.Provider>;
}

export function useLang() { return useContext(LangContext); }
